import type { NextPage } from 'next';
import { AccountContentProvider } from 'components/account/accountContentContext/AccountContentContext';
import { AccountSeoConnected } from 'components/account/accountSeoConnected/AccountSeoConnected';
import { LoginForm } from 'components/loginForm/LoginForm';
import { LoginFormProvider } from 'components/loginForm/LoginFormContext';
import { loggedOutSSRProps } from 'components/route/account/loggedOutSSRProps';

const LoginPage: NextPage = () => {
  return (
    <AccountContentProvider>
      <LoginFormProvider>
        <AccountSeoConnected location="login" />
        <LoginForm />
      </LoginFormProvider>
    </AccountContentProvider>
  );
};

export const getServerSideProps = loggedOutSSRProps;

export default LoginPage;
